import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import { useLocation } from 'react-router-dom';
import DepartmentTable from '../../pages/Organization/Department/Department';
import Designation from '../../pages/Organization/Designation/Designation';
import TRFList from '../../pages/Organization/TRF/TRFList';

import OrganisationChart from '../../pages/Organization/OrganisationChart/OrganisationChart';


const CommonTab: React.FC = () => {
    const location = useLocation();
    const [activeTabKey, setActiveTabKey] = useState(location.state?.activeTab || '1');

    useEffect(() => {
        if (location.state?.activeTab) {
            setActiveTabKey(location.state.activeTab);
        }
    }, [location.state?.activeTab]);

    const handleTabChange = (key: string) => {
        setActiveTabKey(key);
    };

    const items = [
        {
            key: '1',
            label: 'Departments',
            children: <DepartmentTable />, // Render the Home component
        },
        {
            key: '2',
            label: 'Designation',
            children: <Designation />, // Render the Organization component
        },
        {
            key: '3',
            label: 'TRF',
            children: <TRFList />, // Render the TRF component
        },
        {
            key: '4',
            label: 'Organization Chart',
            children: <OrganisationChart />

        }
    ];

    return (
        // <Tabs activeKey={activeTabKey} onChange={handleTabChange}>
        //     {items.map(item => (
        //         <Tabs.TabPane key={item.key} tab={item.label}>
        //             {item.children}
        //         </Tabs.TabPane>
        //     ))}
        // </Tabs>
        <Tabs activeKey={activeTabKey} onChange={handleTabChange} items={items} />
    );
};

export default CommonTab;
